export function normalizePhone(value: string | undefined): string {
  if (!value) return ''
  return value.replace(/\D/g, '')
}

export function formatPhone(phone: string | null | undefined, plus = true): string {
  phone = phone?.replace(/\D/g, '')
  if (!phone) return ''
  if (phone.length === 11) {
    phone = phone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3-$4-$5').replace(/^8 /, '7 ')
  }
  return plus ? '+' + phone : phone
}
